module.exports = __webpack_public_path__ + "static/media/search-circle.10be1e81.svg";